import Reveal from './Reveal';

const stats = [
  { value: '40+', label: '专栏图文拆解' },
  { value: '6', label: '教程板块覆盖' },
  { value: '10 分钟', label: '小白快速上手' },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-[#FBF9F4] pt-28 pb-16 md:pt-36 md:pb-24">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
        {/* 左侧文案 */}
        <div>
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full border border-emerald-600/20 bg-emerald-50 px-3 py-1 text-xs text-emerald-700">
              <i className="ri-flashlight-line text-sm"></i>
              吃瓜软件 · 官网使用指南
            </span>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="mt-6 text-3xl leading-[1.18] font-bold tracking-tight text-stone-900 md:text-5xl">
              把今天的热点
              <br />
              看得更明白一点
            </h1>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-6 max-w-xl text-[15px] leading-7 text-stone-500">
              吃瓜软件使用教程、操作指南、新手入门一站式合集。从下载安装到进阶玩法，每一步都有图文拆解——不用懂技术，跟着做就能上手，玩转吃瓜软件的所有功能。
            </p>
          </Reveal>
          <Reveal delay={240}>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#quickstart"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-emerald-600 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-emerald-700"
              >
                从新手入门开始
                <i className="ri-arrow-right-line text-base"></i>
              </a>
              <a
                href="#guides"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-stone-300 bg-white px-6 py-3 text-sm font-medium text-stone-800 transition-colors hover:border-emerald-600 hover:text-emerald-700"
              >
                <i className="ri-book-open-line text-base"></i>
                查看全部教程
              </a>
            </div>
          </Reveal>
          <Reveal delay={320}>
            <dl className="mt-12 grid grid-cols-3 gap-6 border-t border-black/5 pt-8">
              {stats.map((s) => (
                <div key={s.label}>
                  <dt className="sr-only">{s.label}</dt>
                  <dd className="font-display text-2xl font-semibold text-emerald-700 md:text-3xl">{s.value}</dd>
                  <dd className="mt-1 text-xs text-stone-500">{s.label}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>

        {/* 右侧大幅封面 */}
        <Reveal delay={200} className="relative">
          <div className="relative">
            <div className="overflow-hidden rounded-2xl bg-emerald-50">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20young%20person%20calmly%20lounging%20while%20following%20a%20large%20floating%20tablet%20showing%20a%20clean%20trending%20topics%20feed%20with%20big%20headline%20cards%20and%20category%20pills%2C%20warm%20cream%20paper%20background%2C%20soft%20sage%20green%20and%20melon%20tone%20accents%2C%20minimal%20magazine%20editorial%20aesthetic%2C%20soft%20paper%20grain%20texture%2C%20generous%20negative%20space%2C%20calm%20and%20modern&width=1000&height=1120&seq=hero-cover-2026&orientation=portrait"
                alt="吃瓜软件热点资讯信息流界面插画"
                title="吃瓜软件 · 热点资讯信息流"
                className="h-[420px] w-full object-cover object-top md:h-[520px] lg:h-[560px]"
              />
            </div>

            {/* 悬浮小标签 */}
            <div className="absolute top-5 left-5 rounded-lg bg-white/90 px-3 py-2 backdrop-blur-sm">
              <p className="flex items-center gap-1.5 text-xs font-medium text-stone-800">
                <i className="ri-fire-line text-sm text-rose-500"></i> 今日热点榜 · 实时更新
              </p>
            </div>
            <div className="absolute bottom-5 right-5 rounded-lg bg-stone-900/85 px-4 py-3 backdrop-blur-sm">
              <p className="text-[11px] tracking-wide text-stone-300">订阅我的专题</p>
              <p className="mt-0.5 font-display text-xl font-semibold text-white">48 个进行中</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}